var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconTv = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.314 33a.327.327 0 0 1-.326-.327v-1.901H1.327A.327.327 0 0 1 1 30.444V9.6c0-.18.146-.328.327-.328h31.346A.327.327 0 0 1 33 9.6v20.844a.327.327 0 0 1-.327.328h-8.032v1.9a.329.329 0 0 1-.327.328Zm-12.35-2.884h20.383V9.928H1.653v20.188h10.31Z",
  fill: "#666",
  stroke: "#666",
  strokeWidth: 0.2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.686 33a.327.327 0 0 1-.327-.328v-2.228a.327.327 0 1 1 .653 0v2.229a.327.327 0 0 1-.326.328ZM14.935 25.469a.859.859 0 0 1-.425-.105l-.01-.006c-.447-.27-.523-.8-.495-1.088l.001-8.174c0-.11 0-.787.532-1.028.457-.205 1.03.113 1.139.178l7.196 4.18c.196.107.518.398.518.827 0 .445-.337.736-.544.841l-7.124 4.13c-.071.04-.414.245-.788.245Zm-.102-.677c.135.07.426-.05.546-.127l.013-.008 7.138-4.138.021-.01s.188-.102.188-.26c0-.146-.181-.255-.183-.255l-7.21-4.186c-.177-.105-.446-.188-.543-.144-.112.05-.146.31-.143.41v8.21a.186.186 0 0 1 0 .039s-.032.338.172.467l.001.002Z",
  fill: "#666",
  stroke: "#666",
  strokeWidth: 0.2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.189 33H6.944a.327.327 0 0 1 0-.655h20.245a.327.327 0 0 1 0 .655ZM14.068 7.922a.328.328 0 0 1-.23-.56 4.513 4.513 0 0 1 6.4 0 .327.327 0 0 1-.462.463 3.86 3.86 0 0 0-5.474.001v-.001a.321.321 0 0 1-.234.097Z",
  fill: "#666",
  stroke: "#666",
  strokeWidth: 0.2
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.734 6.181a.328.328 0 0 1-.23-.094 6.308 6.308 0 0 0-4.468-1.858 6.307 6.307 0 0 0-4.467 1.858.325.325 0 0 1-.457-.004.328.328 0 0 1-.004-.46 6.955 6.955 0 0 1 9.86 0 .33.33 0 0 1 .07.357.325.325 0 0 1-.302.202l-.002-.001Z",
  fill: "#666",
  stroke: "#666",
  strokeWidth: 0.2
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.53 4.363a.328.328 0 0 1-.231-.56A9.518 9.518 0 0 1 17.04 1a9.517 9.517 0 0 1 6.74 2.803.328.328 0 0 1-.003.459.325.325 0 0 1-.457.005 8.858 8.858 0 0 0-12.56 0 .332.332 0 0 1-.23.096Z",
  fill: "#666",
  stroke: "#666",
  strokeWidth: 0.2
})));

export default SvgIconTv;